import type { GridInitialStatePro } from "@mui/x-data-grid-pro/models/gridStatePro";

/** What a grid remembers per user: the column layout and the row height, nothing about the data. */
export type StoredGridSettings = Pick<GridInitialStatePro, "density"> & {
  columns?: Pick<
    NonNullable<GridInitialStatePro["columns"]>,
    "columnVisibilityModel" | "orderedFields" | "dimensions"
  >;
};

/**
 * The page's own initial state with the user's settings laid over it.
 *
 * Visibility and widths are merged per column, so a column added later still gets the page's
 * default instead of whatever the stored layout happens to say about it (nothing).
 */
export function mergeGridSettings(
  initialState: GridInitialStatePro | undefined,
  stored: StoredGridSettings | null,
): GridInitialStatePro | undefined {
  if (!stored) return initialState;
  const columns = initialState?.columns;
  return {
    ...initialState,
    density: stored.density ?? initialState?.density,
    columns: {
      ...columns,
      orderedFields: stored.columns?.orderedFields ?? columns?.orderedFields,
      dimensions: { ...columns?.dimensions, ...stored.columns?.dimensions },
      columnVisibilityModel: {
        ...columns?.columnVisibilityModel,
        ...stored.columns?.columnVisibilityModel,
      },
    },
  };
}
